import { Link } from "react-router-dom";
//hooks
import { useTendersAndQuotations, useTotalCounts } from "hooks/api/useStat";
//components
import SubHeader from "./components/SubHeader";
import NotificationList from "./components/NotificationList";

export default function DashboardPage() {
  const { data: totalCount } = useTotalCounts();
  const { data: tendersAndQuotations } = useTendersAndQuotations();

  const stats = [
    {
      name: "Total active tenders",
      stat: totalCount?.active_count.toString(),
      icon: "/active-tender-icon.png",
    },
    {
      name: "Total pending submissions",
      stat: totalCount?.pending_count.toString(),
      icon: "/pending-tender-icon.png",
    },
    {
      name: "Total awarded tenders",
      stat: totalCount?.awarded_count.toString(),
      icon: "/awarded-tender-icon.png",
    },
    {
      name: "Number of awarded tenders",
      stat: totalCount?.awarded_count.toString(),
      icon: "/awarded-icon.png",
    },
  ];

  return (
    <div>
      <SubHeader />
      <div className="mx-auto max-w-6xl w-full px-4 py-3 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-bold mt-4">Your Businesses</h1>
        <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-4">
          {stats.map((item) => (
            <div
              key={item.name}
              className="overflow-hidden rounded-lg bg-white px-4 py-5 sm:p-6 border"
            >
              <img src={item.icon} alt={item.name} className="size-12 mb-4" />
              <dt className="truncate text-sm font-medium text-gray-500">
                {item.name}
              </dt>
              <dd className="mt-1 text-2xl font-semibold tracking-tight text-gray-900">
                {item.stat}
              </dd>
            </div>
          ))}
        </dl>
        <div className="grid grid-cols-3 gap-2 mt-8">
          <div className="col-span-2">
            <div className="mb-4 text-lg font-bold text-gray-900 ">
              Tender And Quotation Status
            </div>
            <div className="flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                        >
                          Title
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {tendersAndQuotations?.map((tender) => (
                        <tr key={tender.title}>
                          <td className=" py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                            <Link className="hover:text-blue-500" to={`/${tender.type == 1 ? "tenders" : "quotations"}/${tender.id}`}>
                              {tender.tender_title}
                            </Link>
                          </td>
                          <td className=" px-3 py-4 text-sm text-gray-500">
                            <span className="capitalize inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                              <svg
                                viewBox="0 0 6 6"
                                aria-hidden="true"
                                className="h-1.5 w-1.5 fill-blue-500"
                              >
                                <circle r={3} cx={3} cy={3} />
                              </svg>
                              {tender.tender_status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="px-4 mb-4 flex items-center justify-between">
              <div className="text-lg font-bold text-gray-900 ">
                Activity
              </div>
              <Link
                to="/notifications"
                className="text-sm text-gray-500 font-medium hover:underline transition-all duration-500"
              >
                View all
              </Link>
            </div>
            <NotificationList limit={10} />
          </div>
        </div>
      </div>
    </div>
  );
}
